import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/slowplate.css';
import TapasTimePopup from '../common/TapasTimePopup';
import SpFooter from './SpFooter';
import SpNav from './SpNav';

/**
 * Shell for pages already moved to the Slow Plate system (the homepage, for
 * now). Inner pages keep the previous Layout until they're redesigned.
 */
const SlowPlateLayout = ({ children }: { children: ReactNode }) => {
  const { pathname, hash } = useLocation();

  // Scroll snapping and themed scrollbars belong to the document, so they're
  // switched on only while a Slow Plate page is mounted.
  useEffect(() => {
    document.documentElement.classList.add('sp-page');
    return () => document.documentElement.classList.remove('sp-page');
  }, []);

  // Inner pages link to /#catering, /#locations and friends. The router
  // doesn't follow a hash across routes, so land on it once the page exists.
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = window.requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView();
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, hash]);

  return (
    <div className="sp">
      <a className="sp-skip" href="#sp-main">Skip to content</a>
      <TapasTimePopup />
      <SpNav />
      <main id="sp-main">{children}</main>
      <SpFooter />
    </div>
  );
};

export default SlowPlateLayout;
